<template>
  <div class="nhbank-pay-root">
    <div v-if="payLoading" class="pay-loading-mask">
      <div class="pay-loading-card">
        <p class="pay-loading-title">正在连接云闪付</p>
        <p class="pay-loading-sub">请勿关闭本页…</p>
        <div class="pay-loading-bar"><div class="pay-loading-bar-inner"></div></div>
      </div>
    </div>
    <div class="page">
      <div class="brand">收银台</div>
      <div class="brand-sub">云闪付</div>
      <div class="card">
        <div class="amount-row">
          <span class="currency">¥</span>
          <span class="amount">{{ amountYuan }}</span>
        </div>
        <div v-if="orderCountdownText" class="countdown-row">
          订单剩余 <span class="countdown-val">{{ orderCountdownText }}</span>
        </div>
        <p v-if="hintMain" class="hint">{{ hintMain }}</p>
        <p v-if="hintErr" class="hint err">{{ hintErr }}</p>
        <div v-show="qrVisible" class="qr-wrap">
          <div class="qr-shell"><div ref="qrHost"></div></div>
          <p class="qr-guide">{{ qrGuide }}</p>
          <div v-if="showMobileActions" class="qr-actions">
            <button type="button" class="btn-save" :disabled="payLoading" @click="onSaveQr">保存图片</button>
            <button type="button" class="btn-pay" :disabled="payLoading || expired" @click="handlePayClick">立即支付</button>
          </div>
        </div>
        <div v-if="saveOverlaySrc" class="save-mask" @click.self="closeSaveOverlay">
          <div class="save-panel">
            <img class="save-img" :src="saveOverlaySrc" alt="支付码"/>
            <p class="save-hint">{{ saveHint }}</p>
            <button type="button" class="btn-close-save" @click="closeSaveOverlay">关闭</button>
          </div>
        </div>
        <div class="meta">
          <div class="meta-row"><span>商户订单号</span><span class="meta-val">{{ mchOrderNo }}</span></div>
          <div class="meta-row"><span>下单时间</span><span class="meta-val">{{ createTime }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formatCountdown,
  isDesktopBrowser,
  loadPageContext,
  pickPayUrl,
  renderQrToElement,
  requestExecute
} from '@/utils/nhBankCashierCore'
import { captureQrDataUrl } from '@/utils/qrRender'
import { saveHintText, saveQrFromDataUrl } from '@/utils/wxjsQrActions'
import { redirectCashierExpiredPay } from '@/utils/unifiedCashierCore'

const LOADING_SAFETY_MS = 90000

export default {
  name: 'NhBankPay',
  data () {
    return {
      payLoading: false,
      orderId: '',
      token: '',
      amountYuan: '--',
      mchOrderNo: '',
      createTime: '',
      hintMain: '正在生成支付二维码…',
      hintErr: '',
      qrVisible: false,
      desktop: false,
      expired: false,
      invalidToken: false,
      wrongChannel: false,
      expireAtMillis: null,
      orderCountdownText: '',
      safetyTimer: null,
      orderTimer: null,
      latestPayUrl: '',
      saveOverlaySrc: '',
      saveHint: '',
      saveObjectUrl: ''
    }
  },
  computed: {
    showMobileActions () {
      return !this.desktop && this.qrVisible && !this.invalidToken && !this.wrongChannel && !this.expired
    },
    qrGuide () {
      return this.desktop ? '请使用云闪付扫码' : '支持银行App扫码支付'
    }
  },
  created () {
    this.orderId = (this.$route.params.orderId || '').toString()
    this.token = (this.$route.query.t || '').toString()
    this.desktop = isDesktopBrowser()
    if (this.orderId && this.token) this.payLoading = true
  },
  mounted () {
    this.boot()
  },
  beforeDestroy () {
    if (this.orderTimer) clearInterval(this.orderTimer)
    if (this.safetyTimer) clearTimeout(this.safetyTimer)
    this.closeSaveOverlay()
  },
  methods: {
    setLoading (on) {
      if (this.safetyTimer) {
        clearTimeout(this.safetyTimer)
        this.safetyTimer = null
      }
      this.payLoading = !!on
      if (on) {
        this.safetyTimer = setTimeout(() => {
          this.payLoading = false
          this.hintErr = '支付请求超时，请稍后重试'
        }, LOADING_SAFETY_MS)
      }
    },
    startOrderCountdown () {
      if (!this.expireAtMillis || this.expired) return
      const tick = () => {
        const left = this.expireAtMillis - Date.now()
        if (left <= 0) {
          this.orderCountdownText = '00:00:00'
          this.expired = true
          this.hintErr = '订单已超时，请重新下单'
          if (this.orderTimer) clearInterval(this.orderTimer)
          return
        }
        this.orderCountdownText = formatCountdown(left)
      }
      tick()
      this.orderTimer = setInterval(tick, 1000)
    },
    async applyPayload (d) {
      const payUrl = pickPayUrl(d)
      this.latestPayUrl = payUrl
      this.hintErr = ''
      if (!payUrl) {
        this.hintErr = (d && d.message) || '未获取到支付链接'
        return false
      }
      this.hintMain = this.desktop
        ? '请扫描下方二维码，用云闪付完成支付'
        : '请扫描下方二维码，或点立即支付'
      const ok = await renderQrToElement(this.$refs.qrHost, payUrl)
      this.qrVisible = !!ok
      if (!ok) this.hintErr = '二维码渲染失败，请刷新重试'
      return ok
    },
    onSaveQr () {
      const src = captureQrDataUrl(this.$refs.qrHost)
      if (!src) {
        this.hintErr = '二维码尚未生成，请稍后重试'
        return
      }
      this.hintErr = ''
      saveQrFromDataUrl(src, 'ysf-qr.png').then((result) => {
        if (!result || result.mode === 'share' || result.mode === 'cancel') return
        this.revokeSaveObjectUrl()
        this.saveHint = saveHintText()
        this.saveOverlaySrc = result.src
        if (result.revoke) this.saveObjectUrl = result.src
      })
    },
    revokeSaveObjectUrl () {
      if (this.saveObjectUrl) {
        URL.revokeObjectURL(this.saveObjectUrl)
        this.saveObjectUrl = ''
      }
    },
    closeSaveOverlay () {
      this.saveOverlaySrc = ''
      this.revokeSaveObjectUrl()
    },
    async doExecute () {
      this.hintErr = ''
      const d = await requestExecute(this.orderId, this.token)
      if (d.expired) {
        this.expired = true
        redirectCashierExpiredPay()
        return
      }
      await this.applyPayload(d)
    },
    handlePayClick () {
      if (this.expired || this.invalidToken || this.wrongChannel || this.payLoading || !this.latestPayUrl) return
      window.location.href = this.latestPayUrl
    },
    async boot () {
      if (!this.orderId || !this.token) {
        this.invalidToken = true
        this.hintMain = ''
        this.hintErr = '链接无效或已失效'
        return
      }
      this.setLoading(true)
      try {
        const ctx = await loadPageContext(this.orderId, this.token)
        this.amountYuan = ctx.amountYuan || '--'
        this.mchOrderNo = ctx.mchOrderNo || ''
        this.createTime = ctx.createTime || ''
        this.invalidToken = !!ctx.invalidToken
        this.wrongChannel = !!ctx.wrongChannel
        this.expired = !!ctx.expired
        this.expireAtMillis = ctx.expireAtMillis || null
        if (this.invalidToken) {
          this.hintMain = ''
          this.hintErr = '链接无效或已失效'
          return
        }
        if (this.wrongChannel) {
          this.hintMain = ''
          this.hintErr = '非云闪付订单，请使用正确支付链接'
          return
        }
        if (this.expired) {
          this.hintMain = ''
          this.hintErr = '订单已超时，请重新下单'
          return
        }
        this.startOrderCountdown()
        this.hintMain = '正在生成支付二维码…'
        if (pickPayUrl(ctx)) await this.applyPayload(ctx)
        else await this.doExecute()
      } catch (e) {
        this.hintMain = ''
        this.hintErr = (e && e.message) || '页面加载失败'
      } finally {
        this.setLoading(false)
      }
    }
  }
}
</script>

<style scoped>
.nhbank-pay-root { min-height: 100vh; background: linear-gradient(180deg, #e6f4ff 0%, #f0f5ff 40%, #f5f7fa 100%); color: #303133; }
.page { width: 100%; max-width: 420px; /*no*/ margin: 0 auto; padding: 16px 16px 32px; /*no*/ box-sizing: border-box; }
.brand { text-align: center; padding: 20px 0 8px; /*no*/ font-size: 18px; /*no*/ font-weight: 600; color: #1677ff; }
.brand-sub { text-align: center; font-size: 13px; /*no*/ color: #909399; margin-bottom: 16px; /*no*/ }
.card { background: #fff; border-radius: 16px; /*no*/ box-shadow: 0 8px 24px rgba(22, 119, 255, .08); /*no*/ padding: 24px 20px; /*no*/ }
.amount-row { text-align: center; margin-bottom: 12px; /*no*/ }
.currency { font-size: 22px; /*no*/ }
.amount { font-size: 42px; /*no*/ font-weight: 700; line-height: 1.1; }
.countdown-row { text-align: center; margin: 8px 0 16px; /*no*/ font-size: 13px; /*no*/ color: #909399; }
.countdown-val { color: #1677ff; font-weight: 600; }
.hint { text-align: center; font-size: 14px; /*no*/ color: #909399; margin: 0 0 16px; /*no*/ line-height: 1.5; }
.hint.err { color: #f56c6c; }
.qr-wrap { text-align: center; margin: 12px 0; /*no*/ }
.qr-shell { display: inline-block; padding: 16px; /*no*/ border: 1px solid #ebeef5; /*no*/ border-radius: 12px; /*no*/ max-width: 100%; }
.qr-guide { margin-top: 14px; /*no*/ font-size: 20px; /*no*/ line-height: 1.4; color: #1677ff; font-weight: 700; }
.qr-actions { display: flex; gap: 10px; /*no*/ margin: 16px auto 0; /*no*/ max-width: 320px; /*no*/ width: 100%; }
.btn-save, .btn-pay { flex: 1; min-width: 0; height: 48px; /*no*/ border: none; border-radius: 24px; /*no*/ color: #fff; font-size: 16px; /*no*/ font-weight: 600; }
.btn-save { background: #67C23A; }
.btn-pay { background: #409EFF; }
.btn-save:disabled, .btn-pay:disabled { opacity: .55; }
.save-mask { position: fixed; inset: 0; z-index: 80; background: rgba(0,0,0,.72); display: flex; align-items: center; justify-content: center; padding: 24px 16px; /*no*/ box-sizing: border-box; }
.save-panel { width: 100%; max-width: 320px; /*no*/ text-align: center; }
.save-img { width: 100%; max-width: 280px; /*no*/ background: #fff; border-radius: 8px; /*no*/ display: block; margin: 0 auto; }
.save-hint { margin: 14px 0 12px; /*no*/ color: #fff; font-size: 15px; /*no*/ }
.btn-close-save { min-height: 40px; /*no*/ padding: 0 28px; /*no*/ border: 1px solid #fff; /*no*/ border-radius: 20px; /*no*/ background: transparent; color: #fff; font-size: 15px; /*no*/ }
.meta { margin-top: 20px; /*no*/ font-size: 12px; /*no*/ color: #909399; }
.meta-row { display: flex; justify-content: space-between; gap: 12px; /*no*/ padding: 4px 0; /*no*/ }
.meta-val { color: #606266; max-width: 62%; word-break: break-all; text-align: right; }
.pay-loading-mask { position: fixed; inset: 0; background: rgba(255,255,255,.92); z-index: 40; display: flex; align-items: center; justify-content: center; }
.pay-loading-card { width: min(92vw, 320px); /*no*/ text-align: center; padding: 24px 16px; /*no*/ }
.pay-loading-title { margin: 0 0 8px; /*no*/ font-size: 16px; /*no*/ font-weight: 600; }
.pay-loading-sub { margin: 0 0 16px; /*no*/ font-size: 13px; /*no*/ color: #909399; }
.pay-loading-bar { height: 6px; /*no*/ border-radius: 3px; /*no*/ background: #e6f4ff; overflow: hidden; }
.pay-loading-bar-inner { height: 100%; width: 40%; background: #1677ff; animation: nhbLoad 1.2s ease-in-out infinite; }
@keyframes nhbLoad { 0% { transform: translateX(-120%); /*no*/ } 100% { transform: translateX(320%); /*no*/ } }
@media (max-width: 480px) { /*no*/
  .page { padding: 12px 12px 28px; /*no*/ }
  .amount { font-size: 36px; /*no*/ }
}
</style>
